import type { SetSummary } from "../core/view/sets.ts";

export function untilText(ms: number): string {
  const minute = 60_000;
  const hour = 60 * minute;
  if (ms < hour) return `in ${Math.max(1, Math.ceil(ms / minute))} min`;
  if (ms < 48 * hour) return `in ${Math.round(ms / hour)} h`;
  return `in ${Math.round(ms / (24 * hour))} d`;
}

export function nextText(set: SetSummary, now: number): string {
  if (set.nextDueAt === null) return "Nothing scheduled";
  return set.nextDueAt <= now ? `${set.due} due now` : `Next review ${untilText(set.nextDueAt - now)}`;
}

export function idleText(set: SetSummary, now: number): string {
  return nextText(set, now).toLowerCase();
}

export function rowLabel(set: SetSummary, now: number): string {
  const parts = [
    set.name,
    `${set.due} due`,
    `${set.lessons} lessons`,
    `${set.mature} mature`,
    `level ${set.level} of ${set.levels}`,
    `${set.total} cards`,
  ];
  parts.push(set.queued ? `starts a session of ${set.queued}` : idleText(set, now));
  return parts.join(", ");
}
